import { registerComponent, debounce, asyncRequest, loading } from "helpers";
import { WYATTElement } from "wyatt";

registerComponent(
  "product-options",
  class ProductOptions extends WYATTElement {
    ELEMENTS_TO_REPLACE = [
      "product-media",
      "product-prices",
      "add-to-cart",
      "inventory-messaging",
      "sku-display",
      "product-options",
      "product-details-vendor-and-sku",
      "other-buying-options",
      "oer-message",
    ];

    constructor() {
      super();

      this.options = this.querySelectorAll("[data-product-option]");
      this.selectedOptions = this.getSelectedOptions();
      [this.productPath, this.productParams] = this.config.url.split("?");
      this.isPDP = window.location.pathname === this.productPath;

      const debouncedHandler = debounce((event) => {
        this.handleOptionChange(event);
      }, 300);

      this.options.forEach((option) => {
        option.addEventListener("change", debouncedHandler.bind(this));
      });
    }

    handleOptionChange(event) {
      const { productUrl } = event.target.dataset;

      loading.add(this);

      if (productUrl) {
        this.updateProductDOM(productUrl);
      } else {
        this.selectedOptions = this.getSelectedOptions();
        this.updateProductDOM();
      }
    }

    getSelectedOptions() {
      const checkedInputs = Array.from(
        this.querySelectorAll("[data-product-option]:checked")
      );

      return checkedInputs.map((input) => input.dataset.productOption);
    }

    async updateProductDOM(productUrl) {
      const url = productUrl || this.getURL();
      const response = await asyncRequest(url);

      if (response) {
        this.handleSuccessfulUpdate(response, productUrl);
      } else {
        this.handleUnsuccessfulUpdate(productUrl);
      }

      loading.remove(this);
    }

    handleSuccessfulUpdate(html, productUrl) {
      const url = productUrl || this.getURL();

      if (productUrl) {
        document.documentElement.innerHTML = html;
      } else {
        this.publish(
          WYATT.config.pubsub.events.updateDOM,
          this.ELEMENTS_TO_REPLACE.map((selector) => ({
            liveRegion: `${selector}-${this.config.product.id}`,
            html,
          }))
        );
      }

      if (this.isPDP) {
        window.history.replaceState(null, "", url);
      }
    }

    handleUnsuccessfulUpdate(productUrl) {
      if (this.isPDP) {
        if (productUrl) {
          window.location.href = productUrl;
        } else {
          window.location.href = this.getURL();
        }
      }
    }

    getURL() {
      const search = new URLSearchParams(this.productParams);
      search.set("option_values", this.selectedOptions.join(","));

      if (this.config.view) {
        search.set("view", this.config.view);
      }

      return `${window.location.origin}${
        this.productPath
      }?${search.toString()}`;
    }
  }
);
